// @flow

import type { DeviceType } from '@chatchamp/chatchamp-types'

export function isMobile (): boolean {
  return window.matchMedia('screen and (max-width: 768px)').matches
}

export function device (): DeviceType {
  return isMobile() ? 'mobile' : 'desktop'
}

export function isIosSafari (): boolean {
  const ua = window.navigator.userAgent
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
  const webkit = !!ua.match(/WebKit/i)

  return iOS && webkit && !ua.match(/CriOS/i)
}
